import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  Button,
  Modal,
  message,
  Spin,
  Divider,
  Tag,
  Space,
  Typography,
  Descriptions,
  Popconfirm,
  Image,
  Card,
  Col,
  Row,
  Empty,
  Checkbox,
  notification,
} from "antd";
import {
  FileTextOutlined,
  BankOutlined,
  CalendarOutlined,
  SaveOutlined,
  FilePdfOutlined,
  UpSquareOutlined,
  DownSquareOutlined,
  AlertOutlined,
  FileSearchOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import axios from "axios";

// import EditJudgeModal from "./EditJudgeModal";
import {
  HEADERS_EXPORT_BEN,
  POST_BILL_PAYMENT,
  POST_LOAD_DETAIL_OLD_DATA,
  POST_LOAN_DB2,
  POST_COMPLETE_ACC_RECHECK_JUDGE_DOC,
  GET_LOAD_IMAGE_NEW_ALL,
  HEADERS_UPIMAGE,
  GET_LOAD_IMAGE_NEW_BY,
  POST_DEBTS_LAWYER_EFF,
  POST_CHECK_HD_PAYMENT,
} from "../../../API/apiUrls";
import PayInSlipModal from "../../afterCourt/report/QRcode";
import ProductTranfer from "../../afterCourt/report/ProductTranfer";
import ProductTranferAccount from "../../afterCourt/report/ProductTranferAccount";
import dayjs from "dayjs";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";

const { Text } = Typography;

const PdfPreviewModal = ({ open, url, onClose }) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    width="90vw"
    style={{ top: 10 }}
    title="ข้อมูล PDF"
  >
    <iframe
      src={url}
      style={{ width: "100%", height: "80vh", border: "none" }}
      title="pdf-preview"
    />
  </Modal>
);

const getDocLabel = (menuType, imageType) => {
  if (menuType === 5 && imageType === 4)
    return { label: "ใบเสร็จศาลคำฟ้อง", color: "#d46b08" }; // ส้มเข้ม
  if (menuType === 6 && imageType === 7)
    return { label: "คำพิพากษา", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 10)
    return { label: "ใบเสร็จศาลหลังพิพากษา", color: "#389e0d" }; // เขียวเข้ม
  return { label: "เอกสาร", color: "#595959" }; // เทาเข้ม
};

// ========================================
// Utility Functions
// ========================================
const formatMoney = (value) => {
  if (!value && value !== 0) return "-";
  return Number(value).toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// ========================================
// Main Component
// ========================================
const AccApproval = ({ open, close, dataDefault, func, process }) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const token = localStorage.getItem("TOKEN");
  const userNNAME = localStorage.getItem("NNAME");

  // States
  const [loading, setLoading] = useState(false);
  const [judgeData, setJudgeData] = useState(null);
  const [lawsuitData, setLawsuitData] = useState(null);
  const [arothrData, setArothrData] = useState([]);
  const [dataDB2, setDataDB2] = useState(null);
  const [billPayment, setBillPayment] = useState(null);
  const [isModalpayIn, setIsModalPayIn] = useState(false);
  const [isModalProductTranfer, setIsModalProductTranfer] = useState(false);
  const [isModalProductTranferAccount, setIsModalProductTranferAccount] =
    useState(false);

  const [fileListByContract, setFileListByContract] = useState([]);
  const [showImage, setShowImage] = useState(false);
  const [isFlagArlost, setIsFlagArlost] = useState(false);
  const [showCheckbox, setShowCheckbox] = useState(false);

  const [fileListByContractCourt, setFileListByContractCourt] = useState([]);
  const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");

  const [impoundCarDate, setImpoundCarDate] = useState(dayjs());

  // ========================================
  // AROTHR Options for display
  // ========================================
  const arothrOptions = useMemo(
    () => [
      { value: "111", label: "ค่าติดตาม" },
      { value: "222", label: "ค่าทนาย" },
      { value: "333", label: "ค่าธรรมเนียม" },
      { value: "444", label: "ค่าใช้จ่ายอื่นๆ" },
    ],
    [],
  );

  // ========================================
  // Load Main Data
  // ========================================
  const loadData = useCallback(async () => {
    if (!dataDefault?.lawsuitId) return;
    console.log("dataDefault", dataDefault);

    setLoading(true);
    try {
      const [loadDetailOldData, loadDataDB2, loadBillPayment] =
        await Promise.all([
          axios.post(
            POST_LOAD_DETAIL_OLD_DATA,
            {
              CONTNO: dataDefault.newContno,
              loanId: dataDefault.loanId,
              lawsuitId: dataDefault.lawsuitId,
            },
            { headers: HEADERS_EXPORT_BEN },
          ),
          axios.post(
            POST_LOAN_DB2,
            {
              CONTNO: `'${dataDefault.CONTNO}'`,
            },
            { headers: HEADERS_EXPORT_BEN },
          ),
          axios.post(
            POST_BILL_PAYMENT,
            {
              CONTNO: dataDefault.newContno || "V" + dataDefault.CONTNO,
            },
            { headers: HEADERS_EXPORT_BEN },
          ),
        ]);

      if (loadDetailOldData?.data) {
        console.log("✅ loadDetailOldData:", loadDetailOldData.data);
        const { judge, lawsult, arothr } = loadDetailOldData.data;

        setJudgeData(judge || null);
        setLawsuitData(lawsult || null);
        setArothrData(arothr || []);
      } else {
        throw new Error("ไม่พบข้อมูลคดี");
      }
      if (loadDataDB2?.data) {
        console.log("✅ loadDataDB2:", loadDataDB2?.data[0]);
        setDataDB2(loadDataDB2?.data[0] || null);
      } else {
        throw new Error("ไม่พบข้อมูลจาก DB2");
      }
      if (loadBillPayment?.data) {
        console.log("✅ loadBillPayment:", loadBillPayment.data);
        if (
          dataDefault.currentStatus === 19 &&
          loadBillPayment?.data?.check8 !== ""
        ) {
          notification.error({
            message: "มีสัญญาใน hp",
            description: (
              <>
                <div style={{ marginBottom: 8 }}>
                  สัญญา : {loadBillPayment?.data?.check8}
                </div>
                <div
                  style={{
                    borderTop: "1px solid #f0f0f0",
                    paddingTop: 8,
                    marginTop: 8,
                    fontSize: "12px",
                    color: "red",
                  }}
                >
                  โปรดตรวจสอบสัญญา !
                </div>
              </>
            ),
            duration: 10,
          });
        }
        setBillPayment(loadBillPayment.data);
      } else {
        throw new Error("ไม่พบข้อมูลบิล");
      }
    } catch (error) {
      console.error("❌ Error loading data:", error);
      message.error(
        error.detailOldData?.data?.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล",
      );
    } finally {
      setLoading(false);
    }
  }, [dataDefault]);

  const loadPath8 = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${GET_LOAD_IMAGE_NEW_ALL}/8/${dataDefault.loanId}`,
        { headers: HEADERS_UPIMAGE },
      );
      setFileListByContract(res.data ?? []);
      setShowImage(true);
    } catch {
      message.error("เกิดข้อผิดพลาดในการโหลดรูปภาพ");
      setFileListByContract([]);
    } finally {
      setLoading(false);
    }
  }, [dataDefault]);

  const loadPath10 = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${GET_LOAD_IMAGE_NEW_ALL}/10/${dataDefault.loanId}`,
        { headers: HEADERS_UPIMAGE },
      );
      setFileListByContract(res.data ?? []);
      setShowImage(true);
    } catch {
      message.error("เกิดข้อผิดพลาดในการโหลดรูปภาพ");
      setFileListByContract([]);
    } finally {
      setLoading(false);
    }
  }, [dataDefault]);

  //เอกสารทนาย
  const loadPath56 = useCallback(async () => {
    setLoading(true);
    try {
      const [imgRes5, imgRes6] = await Promise.all([
        axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/5/${dataDefault.loanId}`, {
          headers: HEADERS_UPIMAGE,
        }),
        axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/6/${dataDefault.loanId}`, {
          headers: HEADERS_UPIMAGE,
        }),
      ]);

      const mapImg = (img) => ({
        ...img,
        CONTNO: dataDefault.CONTNO,
        loanId: dataDefault.loanId,
        lawsuitId: dataDefault.lawsuitId,
      });

      const allImages = [
        ...(imgRes5.data || []).map(mapImg),
        ...(imgRes6.data || []).map(mapImg),
      ];

      if (allImages.length === 0) {
        message.warning("ไม่พบรูปภาพ");
      }

      setFileListByContractCourt(allImages);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาด: ${error.message}`);
      setFileListByContractCourt([]);
    } finally {
      setLoading(false);
    }
  }, [dataDefault]);

  const loadCheckHdpayment = async (payload) => {
    setLoading(true);
    try {
      const res = await axios.post(
        POST_CHECK_HD_PAYMENT,
        {
          DATA_TYPE: dataDefault.SCHEMA,
          CONTNO: dataDefault.CONTNO,
          // DATA_TYPE: "vsfhp",
          // CONTNO: "2-0007649",
        },
        { headers: HEADERS_EXPORT_BEN },
      );
      if (res.status === 201 || res.status === 200) {
        return res.data.data;
      }
    } catch (err) {
      message.error(
        err?.response?.status === 404 ? "ไม่พบข้อมูล" : "เกิดข้อผิดพลาด",
      );
    } finally {
      setLoading(false);
    }
  };

  const lineNoti = async (payload) => {
    setLoading(true);
    console.log("userNNAME", userNNAME);

    try {
      const res = await axios.post(
        "https://noti-lawyer-1024031113167.asia-southeast3.run.app/api/notify/payment/pending-money",
        {
          case_no: payload?.CONTNO,
          case_name:
            dataDB2?.CUSTOMER?.SNAM +
            dataDB2?.CUSTOMER?.NAME1 +
            " " +
            dataDB2?.CUSTOMER?.NAME2,
          notify_to: [1, 33],
          action_by: userNNAME,
          totamt: payload?.TOTAMT,
          kang: payload?.kang,
          message: "มีเงินตั้งพัก/เงินกั๊กคงค้างในคดีนี้ กรุณาตรวจสอบ",
        },
        {
          headers: {
            "X-API-Key": "your-secret-key-here",
            "Content-Type": "application/json",
          },
        },
      );
      if (res.status === 201 || res.status === 200) {
        return res.data.data;
      }
    } catch (err) {
      message.error(
        err?.response?.status === 404 ? "ไม่พบข้อมูล" : "เกิดข้อผิดพลาด",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("1", dataDefault);

    if (open) {
      loadData();
      if (!dataDefault.rejudgeFromIdJudge) {
        loadPath56();
      } else {
        loadPath10();
      }

      if (dataDefault.checkJudgeFn) {
        loadPath8();
      }
    }
  }, [open, loadData, loadPath8, loadPath56, loadPath10, dataDefault]);

  const handleSave = async (status) => {
    setLoading(true);
    try {
      console.log("status", status);
      let payload;
      let apiUse;

      if (status === 99) {
        const checkDataHdPayment = await loadCheckHdpayment();
        console.log("checkDataHdPayment", checkDataHdPayment);
        if (
          Number(checkDataHdPayment?.TOTAMT) > 0 ||
          Number(checkDataHdPayment?.KANG) > 0
        ) {
          lineNoti(checkDataHdPayment);
          notification.error({
            message: "ไม่สามารถ ยึดได้!",
            description: (
              <>
                <div style={{ marginBottom: 8 }}>
                  สัญญา : {checkDataHdPayment.CONTNO}
                </div>
                <div style={{ marginBottom: 8 }}>
                  มียอดตั้งพักจำนวน : {formatMoney(checkDataHdPayment.TOTAMT)}{" "}
                  บาท
                  <br />
                  มียอดเงินกั๊กจำนวน : {formatMoney(
                    checkDataHdPayment.KANG,
                  )}{" "}
                  บาท
                </div>

                <div
                  style={{
                    borderTop: "1px solid #f0f0f0",
                    paddingTop: 8,
                    marginTop: 8,
                    fontSize: "12px",
                    color: "red",
                  }}
                >
                  โปรดเช็คข้อมูลกับการเงิน !
                </div>
              </>
            ),
            duration: 10,
          });
          return null;
        }

        payload = {
          CONTNO: dataDefault.CONTNO,
          DATATYPE: dataDefault.SCHEMA,
          DATE: impoundCarDate.format("YYYY-MM-DD"),
        };
        apiUse = POST_DEBTS_LAWYER_EFF;
      } else {
        payload = {
          judge: judgeData,
          currentStatus: status,
          userId: userId,
          flagArlost: isFlagArlost ? 1 : 0,
        };
        apiUse = POST_COMPLETE_ACC_RECHECK_JUDGE_DOC;
      }

      console.log("📌 Payload ส่ง API:", payload, process);

      const result = await postApprovStatus(payload, apiUse);

      setLoading(true);
      if (func && typeof func === "function") {
        func({
          action: "refresh",
          data: result,
          status: process,
        });
      }

      setLoading(false);
      message.success("บันทึกสำเร็จ");
      close();
    } catch (err) {
      console.error("❌ Error saving:", err);
      message.error(
        status === 3 || status === 6 ? "แก้ไขไม่สำเร็จ" : "บันทึกไม่สำเร็จ",
      );
    } finally {
      setLoading(false);
    }
  };

  // ✅ ฟังก์ชันส่งข้อมูลไป API
  const postApprovStatus = async (payload, apiUse) => {
    console.log("📤 POST_DOC_STATUS with data:", payload);

    try {
      const res = await axios.post(apiUse, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      const { status, data } = res;

      if (status === 200) {
        console.log("✅ API Response:", data);
        return data;
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else if (status === 400) {
        message.error(`ข้อมูลไม่ถูกต้อง: ${serverMsg}`);
      } else if (status === 500) {
        message.error("เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ (500)");
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
        );
      }

      console.error("❌ postDocStatus error:", error);
      throw error;
    }
  };

  // ========================================
  // Handle Cancel
  // ========================================
  const handleCancel = useCallback(() => {
    setJudgeData(null);
    setLawsuitData(null);
    setArothrData([]);
    close(false);
  }, [close]);

  // ========================================
  // Render Judge Info
  // ========================================
  const renderJudgeInfo = useMemo(() => {
    if (!judgeData) return null;

    const { judgeDef, loanNew } = judgeData;

    const FLAG_CONFIG = {
      1: {
        background: "#f6ffed",
        border: "1px solid #b7eb8f",
        label: "ทำยอม",
        badgeColor: "#389e0d",
        badgeBg: "#d9f7be",
      },
      2: {
        background: "#fff2f0",
        border: "1px solid #ffccc7",
        label: "พิพากษา",
        badgeColor: "#cf1322",
        badgeBg: "#ffebe8",
      },
      6: {
        background: "#fff2f0",
        border: "1px solid #ffccc7",
        label: "(ส่วนต่าง)",
        badgeColor: "#cf1322",
        badgeBg: "#ffebe8",
      },
    };

    const flagStyle = FLAG_CONFIG[dataDefault.flagLoanNew] ?? FLAG_CONFIG[1];
    const lawStyle = dataDefault.LAW_TYPE_ID === 6 && FLAG_CONFIG[6];

    return (
      <>
        <Divider orientation="left">
          <BankOutlined /> ข้อมูลคำพิพากษา
          <span
            style={{
              background: flagStyle.badgeBg,
              color: flagStyle.badgeColor,
              borderRadius: 20,
              padding: "2px 10px",
              fontSize: 20,
              fontWeight: 500,
            }}
          >
            {flagStyle.label}
            {lawStyle.label}
          </span>
        </Divider>

        <div
          style={{
            background: "#f6ffed",
            border: "1px solid #b7eb8f",
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "16px",
          }}
        >
          <Descriptions bordered size="small" column={{ xs: 1, sm: 2, md: 3 }}>
            <Descriptions.Item label="เลขคดีแดง">
              <Text strong copyable>
                {judgeData.redCaseNumber || "-"}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="เลขสัญญาใหม่">
              <Text strong copyable>
                {judgeData.newContno || "-"}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="วันพิพากษา">
              {formatDate(judgeData.judgeDate)}
            </Descriptions.Item>
            <Descriptions.Item label="ค่าชดใช้แทน">
              <Text strong style={{ color: "#cf1322" }}>
                {formatMoney(judgeData.judgement)} บาท{" "}
                {!parseInt(judgeData.judgeInterestRate)
                  ? null
                  : ` ดอกเบี้ย ${judgeData.judgeInterestRate}%`}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="ต้นเงิน">
              <Text>
                {formatMoney(judgeData.judgementLack)} บาท{" "}
                {!parseInt(judgeData.interestRate)
                  ? null
                  : ` ดอกเบี้ย ${judgeData.interestRate}%`}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="ดอกเบี้ยก่อนฟ้อง">
              <Text>{formatMoney(judgeData.judgementInterest)} บาท</Text>
            </Descriptions.Item>
            {/* <Descriptions.Item label="ยอดคงเหลือ">
              <Text strong style={{ color: "#fa541c" }}>
                {formatMoney(judgeData.TONBALANCE)} บาท
              </Text>
            </Descriptions.Item> */}
            <Descriptions.Item label="ค่าขาดประโยชน์">
              <Text>
                {formatMoney(judgeData.lackOfBenefits)} บาท{" "}
                {!parseInt(judgeData.interestRateOfLack)
                  ? null
                  : ` ดอกเบี้ย ${judgeData.interestRateOfLack}%`}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="ค่าขาดประโยชน์รายเดือน">
              <Text>
                {formatMoney(judgeData?.judgeDef[0]?.costOfUselesenessPerMonth)}{" "}
                บาท{" "}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="ระยะเวลาค่าขาดประโยชน์รายเดือน">
              <Text>
                {formatMoney(judgeData?.judgeDef[0]?.costOfUselesenessMonth)}{" "}
                เดือน{" "}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="ค่าทนาย">
              <Text>{formatMoney(judgeData.attorneyFees)} บาท</Text>
            </Descriptions.Item>
            <Descriptions.Item label="ค่าติดตาม">
              <Text>{formatMoney(judgeData.trackingFee)} บาท</Text>
            </Descriptions.Item>
            <Descriptions.Item label="ค่าธรรมเนียมศาล">
              <Text>{formatMoney(judgeData.fee)} บาท</Text>
            </Descriptions.Item>
          </Descriptions>
          <Text style={{ fontSize: 16, margin: 10 }}>
            <span style={{ color: "#888" }}>ผู้รับผิดชอบ: </span>
            <span style={{ fontWeight: 500 }}>
              {lawsuitData?.FNAME} {lawsuitData?.LNAME}
            </span>
            <span style={{ fontWeight: 500, marginLeft: 6 }}>
              ({lawsuitData?.NNAME})
            </span>
          </Text>
        </div>

        {/* loanNew */}
        {loanNew && (
          <>
            <Divider orientation="left">
              <CalendarOutlined /> ข้อมูลสัญญาใหม่
            </Divider>
            <div
              style={{
                background: "#e6f7ff",
                border: "1px solid #91d5ff",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "16px",
              }}
            >
              <Descriptions
                bordered
                size="small"
                column={{ xs: 1, sm: 2, md: 3 }}
              >
                <Descriptions.Item label="เลขสัญญาใหม่">
                  <Text strong copyable>
                    {loanNew.NEW_CONTNO || "-"}
                  </Text>
                </Descriptions.Item>
                <Descriptions.Item label="เลขสัญญาเดิม">
                  <Text copyable>{loanNew.ISSUNO || "-"}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="วันทำสัญญา">
                  {formatDate(loanNew.SDATE)}
                </Descriptions.Item>
                <Descriptions.Item label="งวดแรก">
                  {formatDate(loanNew.FDATE)}
                </Descriptions.Item>
                <Descriptions.Item label="งวดสุดท้าย">
                  {formatDate(loanNew.LDATE)}
                </Descriptions.Item>
                <Descriptions.Item label="จำนวนงวด">
                  <Tag color="blue">{loanNew.T_NOPAY} งวด</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="ค่างวด">
                  <Text strong style={{ color: "#1890ff" }}>
                    {formatMoney(loanNew.TOT_UPAY)} บาท
                  </Text>
                </Descriptions.Item>

                <Descriptions.Item label="ยอดคงเหลือ">
                  <Text strong style={{ color: "#fa541c" }}>
                    {formatMoney(loanNew.LOAN_NEW_TONBALANCE)} บาท
                  </Text>
                </Descriptions.Item>
              </Descriptions>
            </div>
          </>
        )}

        {/* AROTHR */}
        {/* {arothrData && arothrData.length > 0 && (
          <>
            <Divider orientation="left">
              <DollarOutlined /> ศาลสั่งต้องจ่าย
            </Divider>
            <Table
              dataSource={arothrData}
              columns={[
                {
                  title: "รหัส",
                  dataIndex: "ARCONT",
                  key: "ARCONT",
                  render: (val) => (
                    <Text style={{ fontFamily: "monospace" }}>{val}</Text>
                  ),
                },
                {
                  title: "รายการ",
                  dataIndex: "PAYFOR",
                  key: "PAYFOR",
                  render: (val) => {
                    const option = arothrOptions.find((o) => o.value === val);
                    return <Tag color="blue">{option?.label || val}</Tag>;
                  },
                },
                {
                  title: "จำนวนเงิน",
                  dataIndex: "PAYAMT",
                  key: "PAYAMT",
                  align: "right",
                  render: (val) => <Text strong>{formatMoney(val)} บาท</Text>,
                },
                {
                  title: "ชำระแล้ว",
                  dataIndex: "SMPAY",
                  key: "SMPAY",
                  align: "right",
                  render: (val) => (
                    <Text style={{ color: "#52c41a" }}>
                      {formatMoney(val)} บาท
                    </Text>
                  ),
                },
              ]}
              rowKey="ARCONT"
              pagination={false}
              size="small"
              style={{ marginBottom: "16px" }}
              summary={(data) => {
                const totalPayamt = data.reduce(
                  (sum, r) => sum + Number(r.PAYAMT || 0),
                  0,
                );
                const totalSmpay = data.reduce(
                  (sum, r) => sum + Number(r.SMPAY || 0),
                  0,
                );
                return (
                  <Table.Summary.Row style={{ background: "#fafafa" }}>
                    <Table.Summary.Cell colSpan={2}>
                      <Text strong>รวมทั้งหมด</Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">
                      <Text strong>{formatMoney(totalPayamt)} บาท</Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">
                      <Text strong style={{ color: "#52c41a" }}>
                        {formatMoney(totalSmpay)} บาท
                      </Text>
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </>
        )} */}
      </>
    );
  }, [judgeData, arothrData, arothrOptions]);

  return (
    <>
      <Modal
        title={
          <Space>
            <FileTextOutlined />
            <span>รายละเอียดสัญญา - {dataDefault?.CONTNO || ""}</span>
          </Space>
        }
        open={open}
        onCancel={handleCancel}
        width={1200}
        footer={null}
        destroyOnHidden
      >
        <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
          {renderJudgeInfo}
          {fileListByContractCourt.length > 0 &&
            !dataDefault.rejudgeFromIdJudge && (
              <>
                <Divider orientation="left">
                  <FileSearchOutlined /> ดูเอกสารทนาย
                </Divider>
                <div style={{ textAlign: "center", marginTop: 10 }}>
                  <>
                    <Row gutter={[8, 8]} justify="center">
                      {fileListByContractCourt.map((file) => {
                        const isPdf = file.path?.toLowerCase().endsWith(".pdf");
                        const previewUrl = `${GET_LOAD_IMAGE_NEW_BY}/${file.path}?token=${token}`;
                        const { label, color } = getDocLabel(
                          file.menuType,
                          file.imageType,
                        );

                        return (
                          <Col key={file.imageId} xs={8} sm={6} md={4}>
                            <div
                              style={{
                                border: `1px solid ${color}`,
                                borderRadius: 8,
                                padding: 8,
                                textAlign: "center",
                                position: "relative",
                              }}
                            >
                              {isPdf ? (
                                // ✅ PDF icon + ดู PDF ซ้อนกัน คลิกได้ทั้งก้อน
                                <div
                                  onClick={() => {
                                    setPdfPreviewUrl(previewUrl);
                                    setPdfPreviewOpen(true);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: 80,
                                    background: "#fff1f0",
                                    borderRadius: 6,
                                    border: "1px dashed #ff4d4f",
                                    gap: 4,
                                  }}
                                >
                                  <FilePdfOutlined
                                    style={{ fontSize: 32, color: "#ff4d4f" }}
                                  />
                                  <span
                                    style={{
                                      fontSize: 11,
                                      color: "#ff4d4f",
                                      fontWeight: 500,
                                    }}
                                  >
                                    <EyeOutlined style={{ marginRight: 4 }} />
                                    ดู PDF
                                  </span>
                                </div>
                              ) : (
                                <img
                                  src={previewUrl}
                                  alt={file.path}
                                  style={{
                                    width: "100%",
                                    height: 80,
                                    objectFit: "cover",
                                    borderRadius: 4,
                                  }}
                                />
                              )}
                              {/* ✅ label ใต้ไฟล์ */}
                              <div
                                style={{
                                  marginTop: 6,
                                  background: color,
                                  color: "#fff",
                                  fontSize: 14,
                                  borderRadius: 4,
                                  padding: "1px 6px",
                                  display: "inline-block",
                                }}
                              >
                                {label}
                              </div>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>

                    <PdfPreviewModal
                      open={pdfPreviewOpen}
                      url={pdfPreviewUrl}
                      onClose={() => {
                        setPdfPreviewOpen(false);
                        setPdfPreviewUrl("");
                      }}
                    />
                  </>
                </div>
              </>
            )}
          {dataDefault.checkJudgeFn === 1 &&
            !dataDefault.rejudgeFromIdJudge && (
              <>
                <div
                  onClick={() => setShowImage((prev) => !prev)}
                  style={{ cursor: "pointer", userSelect: "none" }}
                >
                  <Divider orientation="left" style={{ marginBottom: 0 }}>
                    <Space>
                      <Typography.Text strong>การเงินตัดจ่าย</Typography.Text>
                      <Tag
                        color={showImage ? "blue" : "default"}
                        style={{ marginInlineEnd: 0 }}
                      >
                        {showImage ? (
                          <UpSquareOutlined />
                        ) : (
                          <DownSquareOutlined />
                        )}
                      </Tag>
                    </Space>
                  </Divider>
                </div>
                {showImage &&
                  (fileListByContract.length > 0 ? (
                    (() => {
                      const filteredFiles =
                        fileListByContract?.filter(
                          (e) => e.imageType === 13 || 14,
                        ) || [];
                      if (filteredFiles.length === 0) return null;

                      return (
                        <Spin spinning={loading} size="large" tip="Loading...">
                          <Row gutter={[8, 8]} justify="center">
                            {filteredFiles.map((e, index) => {
                              const isPdf = e.path
                                ?.toLowerCase()
                                .endsWith(".pdf");
                              const label =
                                e.imageType === 14 ? "ใบเสร็จ" : "ใบตัดจ่าย";
                              return (
                                <Col
                                  key={e.path || index}
                                  xs={12}
                                  sm={8}
                                  md={6}
                                  lg={6}
                                  xl={6}
                                >
                                  <div
                                    style={{
                                      position: "relative",
                                      width: "100%",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Card
                                      hoverable
                                      style={{
                                        width: "100%",
                                        textAlign: "center",
                                        padding: "8px",
                                        border: "2px solid #1890ff",
                                      }}
                                    >
                                      {isPdf ? (
                                        <>
                                          <div
                                            onClick={() =>
                                              window.open(
                                                `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                                "_blank",
                                              )
                                            }
                                            style={{
                                              height: "120px",
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              cursor: "pointer",
                                              backgroundColor: "#f0f0f0",
                                              borderRadius: "8px",
                                              border: "1px solid #d9d9d9",
                                            }}
                                          >
                                            <FilePdfOutlined
                                              style={{
                                                fontSize: "40px",
                                                color: "#ff4d4f",
                                              }}
                                            />
                                            <span
                                              style={{
                                                marginTop: "8px",
                                                fontSize: "12px",
                                                color: "#666",
                                              }}
                                            ></span>
                                          </div>

                                          <Tag
                                            color="blue"
                                            style={{
                                              fontSize: 11,
                                              borderRadius: 10,
                                              marginTop: "10px",
                                            }}
                                          >
                                            {label}
                                          </Tag>
                                        </>
                                      ) : (
                                        <>
                                          <Image
                                            width="100%"
                                            height="120px"
                                            src={`${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`}
                                            alt={`รูปภาพ ${index}`}
                                            style={{
                                              objectFit: "cover",
                                              borderRadius: "8px",
                                            }}
                                            preview={{
                                              src: `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                            }}
                                          />

                                          <Tag
                                            color="green"
                                            style={{
                                              fontSize: 11,
                                              borderRadius: 10,
                                              marginTop: "10px",
                                            }}
                                          >
                                            {label}
                                          </Tag>
                                        </>
                                      )}
                                    </Card>
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>
                        </Spin>
                      );
                    })()
                  ) : (
                    <Empty description="ยังไม่อัพโหลดรูปตัดจ่าย" />
                  ))}
              </>
            )}

          {dataDefault.rejudgeFromIdJudge && (
            <>
              <div
                onClick={() => setShowImage((prev) => !prev)}
                style={{ cursor: "pointer", userSelect: "none" }}
              >
                <Divider orientation="left" style={{ marginBottom: 0 }}>
                  <Space>
                    <Typography.Text strong>เอกสารรีไฟแนนซ์</Typography.Text>
                    <Tag
                      color={showImage ? "blue" : "default"}
                      style={{ marginInlineEnd: 0 }}
                    >
                      {showImage ? (
                        <UpSquareOutlined />
                      ) : (
                        <DownSquareOutlined />
                      )}
                    </Tag>
                  </Space>
                </Divider>
              </div>
              {showImage &&
                (fileListByContract.length > 0 ? (
                  (() => {
                    const filteredFiles =
                      fileListByContract?.filter(
                        (e) => e.imageType === 13 || 14,
                      ) || [];
                    if (filteredFiles.length === 0) return null;

                    return (
                      <Spin spinning={loading} size="large" tip="Loading...">
                        <Row gutter={[8, 8]} justify="center">
                          {filteredFiles.map((e, index) => {
                            const isPdf = e.path
                              ?.toLowerCase()
                              .endsWith(".pdf");
                            const label =
                              e.imageType === 17
                                ? "ใบขอยอดปิดรีไฟแนนซ์"
                                : e.imageType === 18
                                  ? "ใบเสร็จตัดจ่าย"
                                  : e.imageType === 19
                                    ? "พิพากษารีไฟแนนซ์"
                                    : null;
                            return (
                              <Col
                                key={e.path || index}
                                xs={12}
                                sm={8}
                                md={6}
                                lg={6}
                                xl={6}
                              >
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                    textAlign: "center",
                                  }}
                                >
                                  <Card
                                    hoverable
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      padding: "8px",
                                      border: "2px solid #1890ff",
                                    }}
                                  >
                                    {isPdf ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            window.open(
                                              `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                              "_blank",
                                            )
                                          }
                                          style={{
                                            height: "120px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            backgroundColor: "#f0f0f0",
                                            borderRadius: "8px",
                                            border: "1px solid #d9d9d9",
                                          }}
                                        >
                                          <FilePdfOutlined
                                            style={{
                                              fontSize: "40px",
                                              color: "#ff4d4f",
                                            }}
                                          />
                                          <span
                                            style={{
                                              marginTop: "8px",
                                              fontSize: "12px",
                                              color: "#666",
                                            }}
                                          ></span>
                                        </div>

                                        <Tag
                                          color="blue"
                                          style={{
                                            fontSize: 11,
                                            borderRadius: 10,
                                            marginTop: "10px",
                                          }}
                                        >
                                          {label}
                                        </Tag>
                                      </>
                                    ) : (
                                      <>
                                        <Image
                                          width="100%"
                                          height="120px"
                                          src={`${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`}
                                          alt={`รูปภาพ ${index}`}
                                          style={{
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                          }}
                                          preview={{
                                            src: `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                          }}
                                        />

                                        <Tag
                                          color="green"
                                          style={{
                                            fontSize: 11,
                                            borderRadius: 10,
                                            marginTop: "10px",
                                          }}
                                        >
                                          {label}
                                        </Tag>
                                      </>
                                    )}
                                  </Card>
                                </div>
                              </Col>
                            );
                          })}
                        </Row>
                      </Spin>
                    );
                  })()
                ) : (
                  <Empty description="ยังไม่อัพโหลดรูปตัดจ่าย" />
                ))}
            </>
          )}

          <Divider orientation="left">
            <FileSearchOutlined /> ดูข้อมูล
          </Divider>

          <div style={{ textAlign: "center", marginTop: 10 }}>
            <Space size="large">
              <Button
                type="primary"
                ghost
                icon={<FileTextOutlined />}
                onClick={() => setIsModalPayIn(true)} // ✅ เปิด Modal
                size="large"
                style={{ minWidth: 120, borderRadius: 8 }}
                loading={loading}
              >
                ดูใบเสร็จ
              </Button>
              <Button
                type="primary"
                ghost
                icon={<FileTextOutlined />}
                onClick={() => setIsModalProductTranfer(true)}
                size="large"
                style={{
                  minWidth: 140,
                  borderRadius: 8,
                  borderColor: "#52c41a",
                  color: "#52c41a",
                }}
                loading={loading}
              >
                ดูใบส่งสินค้า
              </Button>
              <Button
                type="primary"
                ghost
                icon={<FileTextOutlined />}
                onClick={() => setIsModalProductTranferAccount(true)}
                size="large"
                style={{
                  minWidth: 140,
                  borderRadius: 8,
                  borderColor: "#c4861a",
                  color: "#c47a1a",
                }}
                loading={loading}
              >
                รายละเอียดสินค้า
              </Button>
            </Space>
          </div>

          <Divider orientation="left">
            <AlertOutlined /> การจัดการ
          </Divider>
          <Row>
            {dataDefault.checkJudgeCeo &&
            dataDefault.closeContno &&
            (dataDefault.SCHEMA === "rpsl" ||
              dataDefault.SCHEMA === "vsfhp") ? (
              <Col span={24} style={{ textAlign: "center" }}>
                <ThaiDatePicker
                  value={impoundCarDate}
                  onChange={setImpoundCarDate}
                  placeholder="กรุณาเลือกวันที่ยึด"
                  size="large"
                  style={{ width: "20%" }}
                  suffixIcon={<CalendarOutlined />}
                />
              </Col>
            ) : null}
            <Col span={24} style={{ textAlign: "center" }}>
              <div style={{ textAlign: "center", marginTop: 5 }}>
                {dataDefault.currentStatus === 19 &&
                  !dataDefault.rejudgeFromIdJudge && (
                    <>
                      {!showCheckbox ? (
                        <Button onClick={() => setShowCheckbox(true)}>
                          กดตั้งตัดจ่าย:
                          <Text strong style={{ color: "red", fontSize: 16 }}>
                            {billPayment?.check8 === ""
                              ? "-"
                              : billPayment?.check8}
                          </Text>
                        </Button>
                      ) : (
                        <Checkbox
                          checked={isFlagArlost}
                          onChange={(e) => setIsFlagArlost(e.target.checked)}
                        >
                          ตั้งตัดจ่าย:{" "}
                          <Text strong style={{ color: "red", fontSize: 16 }}>
                            {billPayment?.check8 === ""
                              ? "-"
                              : billPayment?.check8}
                          </Text>
                        </Checkbox>
                      )}
                    </>
                  )}
              </div>
              <div style={{ textAlign: "center", marginTop: 10 }}>
                <Space size="large">
                  <Button
                    onClick={handleCancel}
                    size="large"
                    style={{ minWidth: 120, borderRadius: 8 }}
                  >
                    ปิด
                  </Button>
                  {dataDefault.currentStatus === 19 && (
                    <Popconfirm
                      placement="topLeft"
                      title="อัพเดทสถานะตีกลับ"
                      description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย !"
                      onConfirm={() => handleSave(21)}
                      onCancel={() => message.info("ยกเลิกการตีกลับ")}
                      okText="ยืนยัน"
                      cancelText="ยกเลิก"
                      okButtonProps={{ size: "large" }}
                      cancelButtonProps={{ size: "large" }}
                    >
                      <Button
                        type="primary"
                        danger
                        size="large"
                        icon={<SaveOutlined />}
                        style={{ minWidth: 120 }}
                        loading={loading}
                      >
                        ตีกลับ
                      </Button>
                    </Popconfirm>
                  )}
                  {dataDefault.currentStatus === 19 && (
                    <>
                      <Popconfirm
                        placement="topLeft"
                        title="อัพเดทสถานะตรวจรับ"
                        description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย !"
                        onConfirm={() => handleSave(20)}
                        onCancel={() => message.info("ยกเลิกการตรวจรับ")}
                        okText="ยืนยัน"
                        cancelText="ยกเลิก"
                        okButtonProps={{ size: "large" }}
                        cancelButtonProps={{ size: "large" }}
                      >
                        <Button
                          type="primary"
                          size="large"
                          icon={<SaveOutlined />}
                          style={{ minWidth: 120 }}
                          loading={loading}
                        >
                          ตรวจรับ
                        </Button>
                      </Popconfirm>
                    </>
                  )}

                  {dataDefault.checkJudgeCeo &&
                  dataDefault.closeContno &&
                  (dataDefault.SCHEMA === "rpsl" ||
                    dataDefault.SCHEMA === "vsfhp") ? (
                    <Popconfirm
                      placement="topLeft"
                      title="อัพเดทสถานะยึด !"
                      description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย !"
                      onConfirm={() => handleSave(99)}
                      onCancel={() => message.info("ยกเลิกการยึด")}
                      okText="ยืนยันยึด"
                      cancelText="ยกเลิก"
                      okButtonProps={{ size: "large" }}
                      cancelButtonProps={{ size: "large" }}
                    >
                      <Button
                        type="primary"
                        size="large"
                        icon={<SaveOutlined />}
                        style={{ minWidth: 120 }}
                        disabled={
                          dataDefault.currentStatus === 13 ||
                          dataDefault.LAW_TYPE_ID === 6 ||
                          !impoundCarDate
                        }
                        loading={loading}
                      >
                        บันทึกยึด
                      </Button>
                    </Popconfirm>
                  ) : null}
                </Space>
              </div>
            </Col>
          </Row>
        </Spin>
        {isModalpayIn && (
          <PayInSlipModal
            open={isModalpayIn}
            onClose={() => setIsModalPayIn(false)}
            dataDB2={dataDB2}
            billPayment={billPayment}
            lawsuitData={lawsuitData}
          />
        )}
        {isModalProductTranfer && (
          <ProductTranfer
            open={isModalProductTranfer}
            onClose={() => setIsModalProductTranfer(false)}
            dataDB2={dataDB2}
            billPayment={billPayment}
            judgeData={judgeData}
            lawsuitData={lawsuitData}
            dataDefault={dataDefault}
          />
        )}
        {isModalProductTranferAccount && (
          <ProductTranferAccount
            open={isModalProductTranferAccount}
            onClose={() => setIsModalProductTranferAccount(false)}
            dataDB2={dataDB2}
            billPayment={billPayment}
            judgeData={judgeData}
            lawsuitData={lawsuitData}
            dataDefault={dataDefault}
          />
        )}
      </Modal>
    </>
  );
};

export default AccApproval;
